import styled from '../../../../styles/theme';
import { ModalTiresDetailStyled } from '../ModalTiresDetailStyled';

export const ModalTiresDetailStyledOV = styled(ModalTiresDetailStyled)`
    .tires-detail__link {
        color: ${({ theme }) => theme.colors.black};
        text-decoration: none;

        svg path {
            fill: ${({ theme }) => theme.colors.black};
        }

        &:hover {
            color: ${({ theme }) => theme.colors.black};
            text-decoration: underline;
        }
    }
`;
